import {
    createElement,
    addClass,
    addAttribute,
} from 'dom-helper';

import URLBuilder from 'url-builder';
import ENV from '../config/env';

const IFRAME_CLASS = 'gwi-brick-iframe';
const IFRAME_HOLDER_CLASS = 'gwi-brick-iframe-holder';
const BRICK_HEIGHT = '100%';

export default class iFrameBuilder {
  static async build(name, brickConfig) {
    const iframe = await this.buildIframe(name, brickConfig);
    return this.buildIframeHolder(iframe, brickConfig);
  }

  static buildIframeHolder(iframe, brickConfig) {
    let iframeHolder = createElement('div');
    addClass(iframeHolder, IFRAME_HOLDER_CLASS);

    iframeHolder = this.styleHolder(iframeHolder, brickConfig);

    iframeHolder.appendChild(iframe);

    return iframeHolder;
  }

  static async getLocale() {
    if (window.gwiJWLocalePlsDontChange !== undefined) {
      return new Promise((resolve) => {
        resolve(window.gwiJWLocalePlsDontChange);
      });
    }

    let language = window.navigator.userLanguage ||
                    window.navigator.languages[0] ||
                    window.navigator.language;
    if (typeof language !== 'string' || language === '') {
      language = 'en';
    }
    if (language.length > 2) {
      language = language.slice(0, 2).toLowerCase();
    }

    function fetchWithTimeout(url, options, timeout) {
      return Promise.race([
        fetch(url, options),
        new Promise((_, reject) =>
          setTimeout(() => reject(new Error('Request for determining user country time out. Defaulting to US.')), timeout),
        ),
      ]);
    }

    return fetchWithTimeout('https://checkip.justwatch.com', {
      method: 'GET',
    }, 1000)
      .then(res => res.json()).then(j => j.country)
      .catch((res) => {
        console.log(res);
        return 'US';
      })
      .then((res) => { window.gwiJWLocalePlsDontChange = `${language}_${res}`; return window.gwiJWLocalePlsDontChange; });
  }


  static async buildIframe(name, brickConfig) {
    let iframe = createElement('iframe');
    addClass(iframe, IFRAME_CLASS);

    addAttribute(iframe, 'options-expanded', 'false');
    addAttribute(iframe, 'scrolling', 'no');
    addAttribute(iframe, 'frameborder', '0');
    addAttribute(iframe, 'height', BRICK_HEIGHT);
    addAttribute(iframe, 'width', '100%');
    addAttribute(iframe, 'name', name);

    let url = await this.getUrl(brickConfig);
    const locale = await this.getLocale();

    if (url.indexOf(`locale=${locale}`) < 0) {
      url += `&locale=${locale}`;
    }

    addAttribute(iframe, 'src', url);

    iframe = this.styleIframe(iframe);

    return iframe;
  }

  static styleHolder(holder) {
    return holder;
  }

  static styleIframe(iframe) {
    return iframe;
  }

  static async getUrl(brickConfig) {
    const filePath = this.getFilePath();
    const url = URLBuilder.buildUrl(ENV.brickHost, filePath, brickConfig.toQueryParamObject());

    return new Promise(resolve => resolve(url));
  }

  static getFilePath() {
    throw new Error('Abstract method getFilePath is not implemented');
  }
}



// WEBPACK FOOTER //
// ./src/utils/iframe-builder.js